export const featureList = [
  'Full access to Oddbods books',
  'Unlimited access to 4,000+ games & activities',
  'Personalized Daily Learning Path',
  'Add up to 3 children',
  'Insightful and actionable reports',
  'Multiple device compatibility',
];